<sw-page class="topdata-company-name-change-list">
    <template #smart-bar-header>
        <h2>{{ $tc('topdata-better-checkout-company-name-change.list.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="getList">
            {{ $tc('topdata-better-checkout-company-name-change.list.refresh') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            detail-route="topdata.better.checkout.company.name.change.detail"
            identifier="id"
            @page-change="onPageChange"
        >
            <template #column-status="{ item }">
                <sw-badge :variant="getStatusVariant(item.status)">
                    {{ getStatusLabel(item.status) }}
                </sw-badge>
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago
                    :date="item.createdAt"
                    :date-time-format="{ month: '2-digit', day: '2-digit' }"
                />
            </template>
        </sw-entity-listing>
    </template>

    <template #sidebar>
        <sw-sidebar>
            <sw-sidebar-filter-panel
                entity="tdbc_company_name_change_request"
                :filters="listFilters"
                @filters-changed="onFiltersChanged"
            />
        </sw-sidebar>
    </template>
</sw-page>
